/** Hebrew "DD/MM/YYYY בשעה HH:MM" in Israel time, for the email + approval page.
 *  Single source so the emailed deadline and the page deadline always match. */
export function formatApprovalDeadline(iso) {
    const d = new Date(iso);
    // en-GB for the numeric parts → DD/MM/YYYY + 24h HH:MM (slashes, not he-IL's
    // dots); the surrounding wording is Hebrew. Always Israel time.
    const date = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Jerusalem',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(d);
    const time = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Jerusalem',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).format(d);
    return `${date} בשעה ${time}`;
}
// Allowed invoice upload content types (PDF / PNG / JPG) + size cap.
export const RECEIPT_CONTENT_TYPES = ['application/pdf', 'image/png', 'image/jpeg'];
export const RECEIPT_MAX_BYTES = 10 * 1024 * 1024; // 10 MB
// Max length of a coach's correction comment.
export const CORRECTION_COMMENT_MAX = 2000;
//# sourceMappingURL=approval.js.map